import { Component, inject, input, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { FormatPipe } from '@app/pipes/format.pipe';
import { Appointment } from '@app/services/fetch/appointment';

@Component({
  selector: 'afcu-info',
  standalone:true,
  imports: [],
  templateUrl: './info.component.html',
})
export class InfoComponent extends BaseConfigurableComponent implements OnInit{

  reason = input.required<string>()
  
  protected appointment = inject( Appointment )
  protected formatPipe = inject(FormatPipe)
  protected router = inject(Router)

  loading: boolean = true

  protected title: string = ''
  protected content: string = ''
  protected button: {title: string, type:string, action: string}[] = {} as {title: string, type:string, action: string}[]

 constructor (){
    super('information')
  }

  ngOnInit(): void {
    const reason = this.reason().split('/');
    this.handleReason(reason[0]);
  }

  private handleReason(reason: string | undefined): void {
    if (!reason) return;
  
    const handlers: Record<string, () => void> = {
      cancel: () => this.applyTextProperties('cancel'),
      submit: () => this.applyTextProperties('submit'),
      server: () => this.applyTextProperties('server'),
      noavailability: () => this.applyTextProperties('noavailability'),
      noserviceforlanguage: () => this.applyTextProperties('noserviceforlanguage'),
      wrongDate: () => this.applyTextProperties('wrongDate'),
      wrongTimeEarly: () => this.applyTextProperties('wrongTimeEarly'),
      wrongTimeLate: () => this.applyTextProperties('wrongTimeLate'),
      notAvailable: () => this.applyTextProperties('notAvailable'),
      wrongLocation: () => this.applyTextProperties('wrongLocation'),
      expired: () => this.applyTextProperties('expired'),
      session: () => this.applyTextProperties('session'),
      wrongBranch: () => this.applyTextProperties('wrongBranch'),
      wrongService: () => this.applyTextProperties('wrongService')
    };
  
    handlers[reason]?.();
  }

  private applyTextProperties(type: 'wrongTimeLate' | 'wrongTimeEarly' | 'cancel' | 'submit' | 'server' | 'noavailability' | 'wrongDate' | 'notAvailable' | 'wrongLocation' | 'expired' | 'noserviceforlanguage' | 'session' | 'wrongBranch' | 'wrongService'): void {
    const text = this.getText()[type];
    if (text) {
      this.setTextProperties(text);
    }
  }

  protected goToPage(link:string){ 

    if(link.includes('/branchID')){
      this.branch = this.route.snapshot.queryParams['branch']

      if(this.branch !== null)
      link = link.replace('branchID', this.branch)
    }

    // Special handling for "Schedule new timeslot" from conflict
    if (this.reason() === 'notAvailable' && link === '/calendar') {
      // Navigate to calendar but preserve existing query parameters
      this.router.navigate([link], { 
        replaceUrl: true, 
        queryParamsHandling: 'preserve', // Preserve existing state in URL
        queryParams: { 'origin': 'queue' }
      });
    } else {
      
      let query = {}

      if (this.route.snapshot.paramMap.get('origin') !== null )
        query = { 'origin': (link === '/check-in') ? 'kiosk' : 'queue'}

      // Normal navigation
      this.router.navigate([link], { 
        replaceUrl: true, 
        queryParamsHandling: 'merge', 
        queryParams: query
      });
    }
  }
  
  private setTextProperties(text: { title: string; content: string; button: {title: string, type:string, action: string}[] }): void {
    if(this.appointment.errorInfo() !== null){
      this.title = this.formatPipe.transform(text.title, { firstname: this.appointment.errorInfo()?.firstname })
      this.content = this.formatPipe.transform(text.content, { branch: this.appointment.errorInfo()?.branch, time: this.appointment.errorInfo()?.time })
    }else{
      this.title = text.title;
      this.content = text.content
    }
    this.button = text.button;
  }
}
